// extracted by css-extract-rspack-plugin
export default {"dialog":"MTtuitQNEYrN8WdV"};